module.exports = __webpack_public_path__ + "static/media/DiffusalBlade.00e05eeb.png";